import { render, staticRenderFns } from "./EmployeePerformanceSankey.vue?vue&type=template&id=f8ac12c6&scoped=true"
import script from "./EmployeePerformanceSankey.vue?vue&type=script&lang=ts"
export * from "./EmployeePerformanceSankey.vue?vue&type=script&lang=ts"
import style0 from "./EmployeePerformanceSankey.vue?vue&type=style&index=0&id=f8ac12c6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8ac12c6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sahil-meshram/Documents/Eiosys/BFP-Admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f8ac12c6')) {
      api.createRecord('f8ac12c6', component.options)
    } else {
      api.reload('f8ac12c6', component.options)
    }
    module.hot.accept("./EmployeePerformanceSankey.vue?vue&type=template&id=f8ac12c6&scoped=true", function () {
      api.rerender('f8ac12c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/admin/components/EmployeePerformanceSankey.vue"
export default component.exports